export default __webpack_public_path__ + "static/media/linkedin2.439669d7.svg";